import React from 'react';
import PropTypes from 'prop-types';
import ModifyRateModal from './ModifyRateModal';
import AreYouSureModal from '../../components/AreYouSureModal';
import ModificationTableWidget from './ModificationTableWidget';
import { Row, Button, ModalBody, Col } from 'reactstrap';
import { isEmptyString } from '../../lib/Utils';
import AddRateTableWidget from './AddRateTableWidget'
import ImportForm from './ImportForm';
import { toast } from 'react-toastify';
/**
 * Rate management widget
 */
export default class RateManagementWidget extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      bulkEditWindowVisible: false,
      singleEditWindowVisible: false,
      addRateWindowVisible: false,
      removeRateWindowVisible: false,
      updateBaseRatesVisible: false,
      updateCurrentRatesVisible: false,
      updateClientRatesVisible: false,

      text: "",
    };

    this.toggleBulkEditWindow = this.toggleBulkEditWindow.bind(this);
    this.toggleSingleSelectWindow = this.toggleSingleSelectWindow.bind(this);
    this.toggleSetBaseRates = this.toggleSetBaseRates.bind(this);
    this.toggleRevertCurrentRates = this.toggleRevertCurrentRates.bind(this);

    this.showUpdateClientRates = this.showUpdateClientRates.bind(this);
    this.hideUpdateClientRates = this.hideUpdateClientRates.bind(this);
    this.toggleAddRateWindow = this.toggleAddRateWindow.bind(this);
    this.toggleRemoveRateWindow = this.toggleRemoveRateWindow.bind(this);

  }

  showUpdateClientRates() {
    this.setState({ updateClientRatesVisible: true });
  }

  hideUpdateClientRates() {
    this.setState({ updateClientRatesVisible: false });
  }

  toggleBulkEditWindow() {
    if (this.props.selectedObjects.length > 0) {
      this.setState({ bulkEditWindowVisible: !this.state.bulkEditWindowVisible });
    } else {
      toast.error("Select an Item to Edit");
    }

  }

  toggleSingleSelectWindow() {
    if (this.props.selectedObjects.length > 0) {
      this.setState({ singleEditWindowVisible: !this.state.singleEditWindowVisible });
    } else {
      toast.error("Select an Item to Edit");
    }

  }
  toggleSetBaseRates() {
    this.setState({
      updateBaseRatesVisible: !this.state.updateBaseRatesVisible
    });
  }

  toggleRevertCurrentRates() {
    this.setState({
      updateCurrentRatesVisible: !this.state.updateCurrentRatesVisible
    });
  }

  toggleAddRateWindow() {
    this.setState({
      addRateWindowVisible: !this.state.addRateWindowVisible
    });
  }

  toggleRemoveRateWindow() {
    this.setState({
      removeRateWindowVisible: !this.state.removeRateWindowVisible
    });
  }

  render() {

    const {
      previewColumns,
      editColumns,
      addColumns,
      selectedObjects,
      setUiState,
      downloadType,
      onBulkEditAcceptChanges,
      onSingleEditAcceptChanges,
      onUpdateBaseWithCurrent,
      onRevertCurrentRates,
      onSetClientToGlobal,
      onDownload,
      onImport,
      importAccept,
      onRemoveSelected,
      terminalName,
      onAddRateData,
      addRemove
    } = this.props;

    const {
      bulkEditWindowVisible,
      singleEditWindowVisible,
      updateBaseRatesVisible,
      updateCurrentRatesVisible,
      updateClientRatesVisible,
      addRateWindowVisible,
      removeRateWindowVisible
    } = this.state;

    const disableButtons = isEmptyString(terminalName);

    const { toggleRemoveRateWindow, toggleSetBaseRates,
      toggleBulkEditWindow, toggleSingleSelectWindow, toggleRevertCurrentRates, hideUpdateClientRates } = this;

    return (
      <Row>
        <Col>

          <AreYouSureModal
            onSubmit={() => {
              hideUpdateClientRates();
              onSetClientToGlobal();
            }}
            confirmText={terminalName}
            toggle={hideUpdateClientRates}
            isOpen={updateClientRatesVisible}
          />

          <ModifyRateModal
            isOpen={bulkEditWindowVisible}
            toggle={toggleBulkEditWindow}>
            <ModalBody>
              <ModificationTableWidget
                onAccept={() => {
                  toggleBulkEditWindow();
                  onBulkEditAcceptChanges();
                }}
                onReject={toggleBulkEditWindow}
                bulk={true}
                columns={previewColumns}
                data={selectedObjects}
                setUiState={setUiState}
              />
            </ModalBody>
          </ModifyRateModal>

          <ModifyRateModal isOpen={singleEditWindowVisible} toggle={toggleSingleSelectWindow}>
            <ModificationTableWidget
              onAccept={() => {
                toggleSingleSelectWindow();
                onSingleEditAcceptChanges();
              }}
              columns={editColumns}
              bulk={false}
              data={selectedObjects}
              onReject={toggleSingleSelectWindow}
              setUiState={setUiState}
            />
          </ModifyRateModal>

          <div className="pb-5">
            <Button
              disabled={disableButtons} onClick={this.toggleSingleSelectWindow} color="primary" block> <i className="fa fa-pencil " /> &nbsp; Individual Edit</Button>
            <Button disabled={disableButtons} onClick={this.toggleBulkEditWindow} color="primary" block> <i className="fa fa-pencil-square-o" /> &nbsp;
            Bulk Edit</Button>
          </div>
          <div className="pb-5">
            {addRemove ?
            <div>
              <Button disabled={disableButtons} onClick={this.toggleAddRateWindow} color="primary" block> <i className="fa fa-plus" /> &nbsp;
            Add Rates</Button>
              <ModifyRateModal isOpen={addRateWindowVisible} toggle={this.toggleAddRateWindow}>
                <AddRateTableWidget
                  onAccept={(data) => {
                    this.toggleAddRateWindow();
                    onAddRateData(data);
                  }}
                  columns={addColumns}
                  onReject={this.toggleAddRateWindow}
                  setUiState={setUiState}
                />
              </ModifyRateModal>

              <Button disabled={disableButtons} onClick={this.toggleRemoveRateWindow} color="primary" block> <i className="fa fa-minus" /> &nbsp;
            Remove <strong>selected</strong> Rates</Button>
              <AreYouSureModal
                onSubmit={() => {
                  toggleRemoveRateWindow();
                  onRemoveSelected(selectedObjects);
                }}
                confirmText={terminalName}
                isOpen={removeRateWindowVisible} toggle={toggleRemoveRateWindow} />
            </div>
            : null}
          </div>
          <div className="pb-5">
            <p className="text-center"><strong>Reset</strong></p>
            <Button disabled={disableButtons} onClick={this.toggleSetBaseRates} color="secondary" block> &nbsp; Set Base Rates</Button>
            <AreYouSureModal
              onSubmit={() => {
                toggleSetBaseRates();
                onUpdateBaseWithCurrent();
              }}
              confirmText={terminalName}
              toggle={toggleSetBaseRates}
              isOpen={updateBaseRatesVisible}
            />
            <Button disabled={disableButtons} onClick={this.toggleRevertCurrentRates} color="secondary" block>&nbsp; Revert Current Rates </Button>

            <AreYouSureModal
              onSubmit={() => {
                toggleRevertCurrentRates();
                onRevertCurrentRates();
              }}
              confirmText={terminalName}
              toggle={toggleRevertCurrentRates}
              isOpen={updateCurrentRatesVisible}
            />


          </div>
          <div className="pb-3">
            <p className="text-center"><strong>Import/Export</strong></p>
            <Button onClick={onDownload}
              disabled={disableButtons} color="primary" block>
              <i className="fa fa-download" /> &nbsp; {"Download as " + downloadType}
            </Button>
          </div>
          <ImportForm
            accept={importAccept}
            onSubmit={onImport}
            disableButtons={disableButtons} />
        </Col>
      </Row>
    );
  }
}


RateManagementWidget.propTypes = {
  setUiState: PropTypes.func.isRequired,
  previewColumns: PropTypes.array.isRequired,
  editColumns: PropTypes.array.isRequired,
  selectedObjects: PropTypes.array.isRequired,
  onBulkEditAcceptChanges: PropTypes.func.isRequired,

  onSingleEditAcceptChanges: PropTypes.func.isRequired,
  onUpdateBaseWithCurrent: PropTypes.func.isRequired,
  onRevertCurrentRates: PropTypes.func.isRequired,
  onSetClientToGlobal: PropTypes.func,
};

RateManagementWidget.defaultProps = {
  selectedObjects: []
};


// WEBPACK FOOTER //
// ./src/components/RateManagment/RateManagementWidget.js